import * as types from './actionTypes';
import enderecoApi from '../api/enderecoApi'


export function consultaCEPSucess(endereco) {
    
    return { type: types.CONSULTAR_CEP, endereco }
}

export function consultaCEP(cep) {
    return function (dispatch) {
        return enderecoApi.consultaCEP(cep).then(resultado => {
            
            dispatch(consultaCEPSucess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}




/** WEBPACK FOOTER **
 ** ./src/components/actions/enderecoActions.js
 **/